import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

/**
 * 兌換前確認彈窗，樣式比照 SimpleModal。
 *
 * 刻意不把焦點預設在「確認兌換」：彈窗開著時若 PG 用掃碼槍掃了下一位，
 * 掃碼槍結尾的 Enter 會直接幫上一位確認。一定要用手點「確認兌換」才兌換；Esc 或點背景為取消。
 */
const PgConfirmModal = ({ pending, submitting, onConfirm, onCancel, onClosed }) => {
	const open = !!pending;

	return (
		// 關窗動畫結束後 headlessui 會把焦點還給開窗前的元素，要在 afterLeave 之後才能把焦點移回輸入框
		<Transition.Root show={open} as={Fragment} afterLeave={onClosed}>
			<Dialog
				as="div"
				className="relative z-40"
				onClose={() => !submitting && onCancel()}
			>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-200"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-150"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-[#c9c9c9] bg-opacity-65" />
				</Transition.Child>

				<div className="fixed inset-0 flex items-center justify-center p-5">
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-200"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="ease-in duration-150"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<Dialog.Panel className="w-full max-w-[400px] rounded-[8px] bg-white p-6 text-center shadow-xl">
							<Dialog.Title className="noto-sans-tc-medium mb-5 text-[20px] text-[#292929]">
								確認兌換
							</Dialog.Title>

							{pending && (
								<div className="mb-6 rounded-[6px] bg-[#f4f4f4] px-4 py-5">
									<p className="mb-1 text-[22px] tracking-wider text-[#292929]">
										{pending.data.vip_code}
									</p>
									{pending.data.member_name && (
										<p className="mb-2 text-[16px] text-[#292929]">{pending.data.member_name}</p>
									)}
									<span
										className={
											"inline-block rounded-full px-3 py-1 text-[13px] " +
											(pending.data.audience_type === "new"
												? "bg-[#fff6e5] text-[#a86500]"
												: "bg-[#eef8f0] text-[#1f7a35]")
										}
									>
										{pending.data.audience_type === "new" ? "新會員（將現場發券）" : "既有會員"}
									</span>
								</div>
							)}

							<div className="flex gap-3">
								<button
									type="button"
									className="noto-sans-tc-medium flex-1 rounded-[6px] border border-[#292929] py-3 text-[16px] text-[#292929] disabled:opacity-50"
									onClick={onCancel}
									disabled={submitting}
								>
									取消
								</button>
								<button
									type="button"
									className="noto-sans-tc-medium flex-1 rounded-[6px] bg-[#292929] py-3 text-[16px] text-white disabled:opacity-50"
									onClick={onConfirm}
									disabled={submitting}
								>
									{submitting ? "兌換中…" : "確認兌換"}
								</button>
							</div>
						</Dialog.Panel>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition.Root>
	);
};

export default PgConfirmModal;
